import { render, staticRenderFns } from "./imports-index.vue?vue&type=template&id=27741008&scoped=true&"
import script from "./imports-index.vue?vue&type=script&lang=js&"
export * from "./imports-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27741008",
  null
  
)

export default component.exports